// Projects filter
export function initProjectsFilter() {
    const selects = document.querySelectorAll('#projects-filter');
    const container = document.querySelector('#projects-results');
    const loadMoreBtn = document.querySelector('#projects-load-more');
	const loader = document.querySelector('#loading-indicator');

	if (!selects || !container || !loader) {
		return;
	}

    let currentExpertise = 'all';
    let currentPage = 1;
    let maxPages = 1;

    async function fetchProjects(reset = false) {
        const formData = new FormData();

        formData.append('action', 'filter_projects');
        formData.append('expertise', currentExpertise);
        formData.append('paged', currentPage);

		// Show loader.
		loader.classList.remove('opacity-0');

		// Fade out container.
		container.classList.remove('opacity-100');
        container.classList.add('opacity-0');

        const req = await fetch(levalux_xhr.url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const res = await req.json();

        maxPages = parseInt(res.max_pages);

		// Inject HTML
		if (reset) {
			container.innerHTML = res.html;
		} else {
			container.insertAdjacentHTML('beforeend', res.html);
		}

		// Hide loader
		loader.classList.add('opacity-0');

		// Fade container back in
		requestAnimationFrame(() => {
			container.classList.remove('opacity-0');
			container.classList.add('opacity-100');
		});

        // Load more toggling
        if (currentPage >= maxPages) {
            loadMoreBtn.parentNode.style.display = 'none';
        } else {
            loadMoreBtn.parentNode.style.display = 'flex';
        }
    }

	// Filter change
	selects.forEach(select => {
		select.addEventListener('change', () => {
			currentExpertise = select.value;
			currentPage = 1;

				selects.forEach(s => {
				if (s !== select) {
					s.value = currentExpertise;
				}
			});

			fetchProjects(true);
		});
	});

    // Load more
	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', () => {
			currentPage++;

			fetchProjects(false);
		});
	}
}
